export const WEBSITE_HOST = location.host.replace("app.", "");
export const WEBSITE_URL = `https://${WEBSITE_HOST}`;
